<template>
    <div class="profile">
        <AccountProfileHeader :subProfilesList="subProfilesList" :selectedSubProfile="selectedSubProfile" @selectSubProfile="selectSubProfile"></AccountProfileHeader>

        <template v-if="subProfilesList && subProfilesList.length">
            <template v-for="subProfile in subProfilesList" :key="subProfile._id">
                <AccountProfileSingle :subProfile="subProfile" v-if="selectedSubProfile === subProfile._id" data-aos="fade-in"></AccountProfileSingle>
            </template>
        </template>

        <template v-else>
            <span class="profile__empty">Nie dodałeś jeszcze profilu dziecka</span>
        </template>
    </div>
</template>

<script>
import AccountProfileHeader from "./AccountProfileHeader.vue"
import AccountProfileSingle from "./AccountProfileSingle.vue"

export default {
    name: "AccountProfile",
    components: {
        AccountProfileHeader,
        AccountProfileSingle
    },
    data() {
        return {
            selectedSubProfile: ''
        };
    },
    computed: {
        selectedAvatar() {
            return this.$store.getters.getSelectedAvatar;
        },
        subProfilesList() {
            return this.$store.getters.getSubProfiles;
        }
    },
    watch: {
        subProfilesList() {
            // jeśli profil nie był wybrany lub usunięto ostatnio aktywny 
            if(this.subProfilesList && this.subProfilesList.length) {
                if(!this.selectedSubProfile || !this.subProfilesList.some(e => e._id === this.selectedSubProfile)) {
                    this.selectedSubProfile = this.subProfilesList[0]._id;
                }
            }
        }
    },
    methods: {
        selectSubProfile(id) {
            this.selectedSubProfile = id;
        }
    },
    mounted() {
        this.$store.dispatch("subProfiles");

        if(this.subProfilesList && this.subProfilesList.length) {
            if(!this.selectedSubProfile || !this.subProfilesList.some(e => e._id === this.selectedSubProfile)) {
                this.selectedSubProfile = this.subProfilesList[0]._id;
            }
        }      
    }
};
</script>